/**
 * Extract GitHub resource details from step output parameters for analytics tracking.
 * Handles variations in field naming (e.g., repo vs repoName) across different workflows.
 */
export function extractGitHubResourceDetails(stepOutputParams: any) {
  const prUrl = stepOutputParams.pullRequestUrl || stepOutputParams.prUrl;
  const prNumber =
    stepOutputParams.pullRequestNumber || stepOutputParams.prNumber;
  const issueUrl = stepOutputParams.issueUrl;
  const issueNumber = stepOutputParams.issueNumber;

  // Build repository identifier from owner and repo fields
  const owner = stepOutputParams.owner;
  const repo = stepOutputParams.repo || stepOutputParams.repoName;
  const repository = owner && repo ? `${owner}/${repo}` : undefined;

  return { prUrl, prNumber, issueUrl, issueNumber, owner, repo, repository };
}
